import React, { Component, createRef } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faTrash,
  faXmark,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import { printFunction } from "../../components/print/printTemplate.js";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";

class PartyWiseNetRateMaster extends Component {
  constructor(props) {
    super(props);
    this.printRef = createRef();
    this.itemMasterServices = new ItemMasterServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      companyName: '',
      partyDropdownList: [],
      companyItemList: [],
      partyId: "",
      tableStatus: "",
      partyWiseRateDetails: {
        partyId: "",
        itemId: "",
        netRate: "",
        freePersantage: "",
        supply: "",
      },
      partyWiseNetRateList: [],
      supplyList: [{ supply: "Yes" }, { supply: "No" }],
      isHideAddItem: false,
    };
  }

  componentDidMount() {
    this.getAllPartyDropdown();
    const company = getAuthProps()
    this.setState({ companyName: company?.companyName })
  }

  getAllPartyDropdown = () => {
    this.commonServices.getAllPartyDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.partyName,
          value: item._id,
        }));
        this.setState({ partyDropdownList: dropdownItems }, () => {
          this.getAllItem();
        });
      } else {
        this.getAllItem();
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  getAllItem = () => {
    this.commonServices.getAllItem().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;

        let dropdownItems = res.map((item) => ({
          label: item.ItemName,
          value: item._id,
        }));

        this.setState({ companyItemList: dropdownItems });
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  addItemforParty = () => {
    this.setState({ isHideAddItem: true });
    let partyWiseArray = this.state.partyWiseNetRateList.map((item) => ({
      ...item,
      isEditing: false,
    }));
    let newItem = {
      itemId: "",
      partyId: this.state.partyWiseRateDetails.partyId,
      freePersantage: 0,
      supply: "Yes",
      isEditing: true,
    };
    partyWiseArray.unshift(newItem);
    this.setState({ partyWiseNetRateList: partyWiseArray });
  };

  editDetails = (index) => {
    let array = this.state.partyWiseNetRateList.map((item, i) => {
      return {
        ...item,
        isEditing: i === index,
      };
    });
    this.setState({ partyWiseNetRateList: array });
  };

  cancelEditing = (id, index) => {
    if (id !== "") {
      let partyWiseArray = this.state.partyWiseNetRateList.map((item) => ({
        ...item,
        isEditing: false,
      }));
      this.setState({ partyWiseNetRateList: partyWiseArray });
    } else {
      let partyWiseArray = [...this.state.partyWiseNetRateList];
      partyWiseArray.splice(index, 1);
      this.setState({ partyWiseNetRateList: partyWiseArray }, () => {
        let filteredArray = this.state.partyWiseNetRateList.filter(
          (x) => x.partyId === ""
        );
        if (filteredArray.length === 0) {
          this.setState({ isHideAddItem: false });
        }
      });
    }
  };

  getPartyWiseNetRateDetailsByPartyId = () => {
    this.setState({ tableStatus: "Loading..." })
    let request = this.state.partyId;
    this.itemMasterServices
      .getPartyWiseNetRateDetailsByPartyId(request)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          if (response.responseData.length === 0) {
            this.setState({ tableStatus: "No Record Found" })
          } else {
            this.setState({ tableStatus: "" })
          }
          let array = response.responseData;
          array.map((item) => {
            item.itemName = this.state.companyItemList.find(
              (x) => x.value === item.itemId
            ).label;
            item.isEditing = false;
          });
          this.setState({ partyWiseNetRateList: array }, () => {
            let filteredArray = this.state.partyWiseNetRateList.filter(
              (x) => x.partyId === ""
            );
            if (filteredArray.length === 0) {
              this.setState({ isHideAddItem: false });
            }
          });
        } else {
          this.setState({ tableStatus: "" })
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };

  handleChange = (event, fieldName, key) => {
    const { value } = event.target;
    const updatedList = this.state.partyWiseNetRateList.map((item, index) =>
      index === key ? { ...item, [fieldName]: value } : item
    );
    this.setState({ partyWiseNetRateList: updatedList });
  };

  handleDropdownChange = (event, fieldName, key) => {
    const { value } = event.target;
    const updatedList = this.state.partyWiseNetRateList.map((item, index) =>
      index === key ? { ...item, [fieldName]: value } : item
    );
    this.setState({ partyWiseNetRateList: updatedList });
    // this.setState((prevState) => {
    //   const updatedList = [...prevState.partyWiseNetRateList];
    //   updatedList[key] = { ...updatedList[key], [fieldName]: value };
    //   return { partyWiseNetRateList: updatedList };
    // });
  };

  setFilterParameters = (selected, fieldName, key) => {
    let value = selected.value;
    const updatedList = this.state.partyWiseNetRateList.map((item, index) =>
      index === key
        ? { ...item, [fieldName]: value, itemName: selected.label }
        : item
    );
    this.setState({ partyWiseNetRateList: updatedList });
    // this.setState((prevState) => {
    //   const updatedList = [...prevState.partyWiseNetRateList];
    //   updatedList[key] = { ...updatedList[key], [fieldName]: selected.value };
    //   return { partyWiseNetRateList: updatedList };
    // });
  };

  setFilterParametersForPartyname = (selected) => {
    if (selected.value) {
      this.setState({ partyId: selected.value }, () => {
        this.getPartyWiseNetRateDetailsByPartyId();
      });
    }
  };

  addEditpartyWiseNetRateDetails = (itemDetails) => {
    if (itemDetails.itemId != "") {
      let request = itemDetails;
      request.partyId = this.state.partyId;
      this.itemMasterServices
        .addEditpartyWiseNetRateDetails(request)
        .then((response) => {
          if (response.statusCode === 200 && response.responseData !== null) {
            this.SwalServices.Success(response.Message);
            this.getPartyWiseNetRateDetailsByPartyId();
          } else {
            this.SwalServices.Error(
              response.Message
            );
          }
        });
    } else {
      this.SwalServices.Alert("Please fill all the required things.");
    }
  };

  deletePartyWiseNetRateById = (id) => {
    if (id && id !== "") {
      this.itemMasterServices
        .deletePartyWiseNetRateById(id)
        .then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.SwalServices.Success(response.Message);
            this.getPartyWiseNetRateDetailsByPartyId();
          } else {
            this.SwalServices.Error(
              response.Message
            );
          }
        });
    }
  };

  render() {
    return (
      <div className="partyWiseRate-page">
        <div className="item-search">
          <div className="item-grp flex gap-2.5">
            <div
              className="item-search-box "
              style={{ width: "50%" }}
            >
              <label>Party Name</label>
              <MultiSelectDropdown
                drpIdentity="PartyId"
                options={this.state.partyDropdownList}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                onChange={(selected) =>
                  this.setFilterParametersForPartyname(selected, "partyId")
                }
                allowSelectAll={false}
                value={this.state.partyDropdownList.filter(
                  (party) =>
                    party.value === this.state.partyId
                )}
              />
            </div>
            {this.state.partyId !== "" ? (
              <div className="btn-grp">
                <button
                  disabled={this.state.isHideAddItem}
                  className={`add-btn mt-auto print:hidden ${this.state.isHideAddItem === true ? "disable-button" : ""
                    }`}
                  onClick={() => this.addItemforParty()}
                >
                  Add Item
                </button>
                {this.state.partyWiseNetRateList.length > 0 ?
                  <button
                    disabled={this.state.isHideAddItem === true}
                    className={`print-btn mt-auto print:hidden`}
                    onClick={() => printFunction()}

                  >
                    Print
                  </button>
                  : null}
              </div>
            ) : null}
          </div>
          {/* <button className="add-btn" onClick={() => this.getPartyWiseNetRateDetailsByPartyId()}>
            Search
          </button> */}
        </div>
        <div className="item-listing">
          <div className="hidden print-title">
            <h4 className="text-black font-bold leading-tight">Party Wise Net Rate Report</h4>
          </div>
          <div className="itemList-table">
            <div className="table-container" style={{ height: "calc(100vh - 125px)" }}>
              <table className="itemList">
                <thead style={{ zIndex: 2 }}>
                  <tr>
                    <td className="!w-[50%]">Item Name</td>
                    <td className="!w-[13%]">Net Rate</td>
                    <td className="!w-[13%]">Free [%]</td>
                    <td className="!w-[13%]">Supply</td>
                    <td className="!w-[11%] !text-center no-print ">
                      Action
                    </td>
                  </tr>
                </thead>
                {this.state.partyWiseNetRateList &&
                  this.state.partyWiseNetRateList.length > 0
                  ? this.state.partyWiseNetRateList.map((details, key) => (
                    <tbody>
                      <tr>
                        <td>
                          {details.isEditing === true ? (
                            <MultiSelectDropdown
                              drpIdentity="ItemId"
                              options={this.state.companyItemList}
                              closeMenuOnSelect={true}
                              hideSelectedOptions={false}
                              onChange={(selected) =>
                                this.setFilterParameters(
                                  selected,
                                  "itemId",
                                  key
                                )
                              }
                              allowSelectAll={false}
                              value={this.state.companyItemList.filter(
                                (party) => party.value === details.itemId
                              )}
                            />
                          ) : (
                            details.itemName
                          )}
                        </td>
                        <td>
                          {details.isEditing === true ? (
                            <input
                              className="inputFocus"
                              type="number"
                              id="netRate"
                              name="netRate"
                              autoComplete="off"
                              value={details.netRate}
                              onChange={(event) =>
                                this.handleChange(event, "netRate", key)
                              }
                            />
                          ) : (
                            details.netRate
                          )}
                        </td>
                        <td>
                          {details.isEditing === true ? (
                            <input
                              className="inputFocus"
                              type="number"
                              id="freePersantage"
                              name="freePersantage"
                              autoComplete="off"
                              value={details.freePersantage}
                              onChange={(event) =>
                                this.handleChange(
                                  event,
                                  "freePersantage",
                                  key
                                )
                              }
                            />
                          ) : (
                            details.freePersantage
                          )}
                        </td>
                        <td>
                          {details.isEditing === true ? (
                            <select
                              name="supply"
                              value={details.supply}
                              onChange={(e) =>
                                this.handleDropdownChange(e, "supply", key)
                              }
                            >
                              <option>Select</option>
                              {this.state.supplyList.map((x, key) => (
                                <option key={key} value={x.supply}>
                                  {x.supply}
                                </option>
                              ))}
                            </select>
                          ) : (
                            // <input  
                            // className="inputFocus"
                            //   type="text"
                            //   id="supply"
                            //   name="supply"
                            //   value={details.supply}
                            //   onChange={(event) => this.handleChange(event, "supply", key)}
                            // />
                            details.supply
                          )}
                        </td>
                        <td style={{ textAlign: "center" }} className="print:!hidden no-print ">
                          {details.isEditing === true ? (
                            <button
                              className="search-btn"
                              onClick={() =>
                                this.addEditpartyWiseNetRateDetails(details)
                              }
                            >
                              <FontAwesomeIcon icon={faCheck} />
                            </button>
                          ) : (
                            <button
                              className="search-btn"
                              disabled={this.state.isHideAddItem}
                              onClick={() => this.editDetails(key)}
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </button>
                          )}
                          {details.isEditing === true ? (
                            <button
                              className="cancel-btn"
                              onClick={() =>
                                this.cancelEditing(
                                  details._id ? details._id : "",
                                  key
                                )
                              }
                            >
                              <FontAwesomeIcon icon={faXmark} />
                            </button>
                          ) : (
                            // Delete
                            <button
                              className="cancel-btn"
                              disabled={this.state.isHideAddItem}
                              onClick={() =>
                                this.deletePartyWiseNetRateById(
                                  details._id ? details._id : ""
                                )
                              }
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  ))
                  : this.state.partyWiseNetRateList &&
                    this.state.partyWiseNetRateList.length === 0
                    && this.state.tableStatus !== "" ? (
                    <tr>
                      <td colSpan={5} style={{ textAlign: "center", fontSize: "16px" }}>
                        {this.state.tableStatus}
                      </td>
                    </tr>
                  ) : this.state.partyWiseNetRateList &&
                    this.state.partyWiseNetRateList.length === 0
                    && this.state.tableStatus === "" ? null : ""}
              </table>
            </div>

          </div>
        </div>

        {/*----- Print layout -----*/}
        <div className='table-print mt-5 hidden' id="printableArea">
          {/* Header */}
          <div className="print-header">
            <table className="hdr-table">
              <tbody>
                <tr>
                  <td>
                    <div className="co-name">{this.state.companyName}</div>
                    <div className="rpt-sub">Party Wise Net Rate Report [Party name : {this.state.partyDropdownList.find((party) => party.value === this.state.partyId)?.label}]</div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="rule-thick" />
            <div className="rule-thin" />
          </div>


          <div className="print-content">

            {/* <div className="info-row">
              <div>
                <span className="info-label">Item Name:</span>
                <p className="info-value">Paracetamol</p>
              </div>
            </div> */}

            {/* Table */}
            <table className="data-tbl">
              <colgroup>
                <col style={{ width: "10%" }} />
                <col style={{ width: "30%" }} />
                <col style={{ width: "20%" }} />
                <col style={{ width: "20%" }} />
                <col style={{ width: "20%" }} />
              </colgroup>

              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    Sr No
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Stage Name
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Net Qty
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Free [%]
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Supply
                  </th>
                </tr>
              </thead>

              <tbody>
                {this.state.partyWiseNetRateList &&
                  this.state.partyWiseNetRateList.length > 0
                  ? this.state.partyWiseNetRateList.map((details, key) => (
                    <tr key={key}>
                      <td style={{ textAlign: 'left' }}>
                        {key + 1}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {details.itemName}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.netRate}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.freePersantage}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.supply}
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="5" style={{ textAlign: 'center' }}>
                        No Data Found
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div className="print-footer">
            <div className="rule-foot">
              <table className="foot-tbl">
                <tbody>
                  <tr>
                    <td>* System generated report. No signature required.</td>
                    <td style={{ textAlign: "right" }}>
                      Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default PartyWiseNetRateMaster;
